import React from "react";
import {useParams} from "react-router-dom";
import Image1920x156 from "../img/thumb/photo-1920x156--2.jpg";
import {Config} from "../Config";
import * as Utils from "../inc/Utils";
import Frame100x60 from "../img/thumb/frame-100x60.png";

export default function ExpertsDetail(prop) {
    let {slug} = useParams();

    let [detail, setDetail] = React.useState(null);
    let [isPublished, setPublished] = React.useState(true);

    React.useEffect(() => {

        (async function() {
            try {
                const resDetail = await getDetail();
                if(resDetail) {
                    if(prop !== null && prop.lang === 'en') {
                        resDetail.title = resDetail.title_en;
                        resDetail.detail = resDetail.detail_en;
                    }
                    setDetail(resDetail);
                }

            } catch (e) {
                //
            }
        })();
    }, []);

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'experts/viewSlug', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                slug: slug
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                <img src={Image1920x156} alt="" />
                <div className="container">
                    <p data-aos="fade-in"><a href={prop.lang === 'en' ? '/en':'/'}>{prop.lang === 'en' ? 'Home':'หน้าแรก'}</a> / <a href={prop.lang === 'en' ? '/en/experts':'/experts'}>{prop.lang === 'en' ? 'Experts':'ผู้เชี่ยวชาญ'}</a></p>
                    <h1 className="h2 textrow">
                        <span data-aos="fade-in">{prop.lang === 'en' ? 'Experts':'ผู้เชี่ยวชาญ'}</span>
                    </h1>
                </div>
            </div>

            <div className="section bg-light">
                <div className="container">
                    <div className="content">
                        <div className="card-infos">
                            <h3 className="text-primary fs-20">{detail?.title}</h3>

                            <hr className="mb-4" />

                            <ul className="infos-list m-0">
                                <li>
                                    <h6>{prop.lang === 'en' ? 'Department':'สังกัด'} :</h6>
                                    <p>{detail?.department ?? '-'}</p>
                                </li>
                                <li>
                                    <h6>{prop.lang === 'en' ? 'Expertise':'ความเชี่ยวชาญ'} :</h6>
                                    <p>{detail?.expertise ?? '-'}</p>
                                </li>
                            </ul>

                            <div className="card-accordion mt-4">
                                <div className="card-header" data-bs-toggle="collapse" data-bs-target="#collapse1"
                                     aria-expanded="false">
                                    <h2>{prop.lang === 'en' ? 'Workings':'ผลงาน'}</h2>
                                </div>

                                <ul className="nav nav-links in-accordion">
                                    <li>
                                        <a className={isPublished ? "active":''} href="#!" onClick={e => setPublished(true)}>
                                            <span className="line-animate">{prop.lang === 'en' ? 'Published works':'ผลงานตีพิมพ์'}</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a className={!isPublished ? "active":''} href="#!" onClick={e => setPublished(false)}>
                                            <span className="line-animate">{prop.lang === 'en' ? 'Research work':'ผลงานวิจัย'}</span>
                                        </a>
                                    </li>
                                </ul>

                                {
                                    detail?.expertsData.length > 0 ?
                                        detail?.expertsData.map((rs, idx) => {
                                            return (
                                                <>
                                                    {
                                                        rs.workTypeId === 1 && isPublished ?
                                                            <div key={idx} className="card-body">
                                                                <h3>{Utils.cleanOutput(prop.lang === 'en' ? rs.title_en:rs.title)}</h3>
                                                                <div dangerouslySetInnerHTML={{__html: prop.lang === 'en' ? rs.detail_en:rs.detail}}></div>

                                                                {
                                                                    rs?.embed || rs?.embed2 || rs.embed3 || rs?.embed4 || rs?.embed5 ?
                                                                        <h3 className="mt-5">{prop.lang === 'en' ? 'Experts Reports':'สถิติที่เกี่ยวข้อง'}</h3>  :''
                                                                }

                                                                {
                                                                    rs.embed ?
                                                                        <div className="mt-5">
                                                                            <div className="iframe-wrapper">
                                                                                <div className="iframe-container">
                                                                                    <div dangerouslySetInnerHTML={{__html: rs.embed}}></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        : ''
                                                                }

                                                                {
                                                                    rs.embed2 ?
                                                                        <div className="mt-5">
                                                                            <div className="iframe-wrapper">
                                                                                <div className="iframe-container">
                                                                                    <div dangerouslySetInnerHTML={{__html: rs.embed2}}></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        : ''
                                                                }

                                                                {
                                                                    rs.embed3 ?
                                                                        <div className="mt-5">
                                                                            <div className="iframe-wrapper">
                                                                                <div className="iframe-container">
                                                                                    <div dangerouslySetInnerHTML={{__html: rs.embed3}}></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        : ''
                                                                }

                                                                {
                                                                    rs.embed4 ?
                                                                        <div className="mt-5">
                                                                            <div className="iframe-wrapper">
                                                                                <div className="iframe-container">
                                                                                    <div dangerouslySetInnerHTML={{__html: rs.embed4}}></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        : ''
                                                                }

                                                                {
                                                                    rs.embed5 ?
                                                                        <div className="mt-5">
                                                                            <div className="iframe-wrapper">
                                                                                <div className="iframe-container">
                                                                                    <div dangerouslySetInnerHTML={{__html: rs.embed5}}></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        : ''
                                                                }
                                                            </div> : ''
                                                    }
                                                </>
                                            )
                                        }) : <p className="text-center">{prop.lang === 'en' ? 'Data Not Found':'ไม่พบข้อมูล'}</p>
                                }

                                {
                                    detail?.expertsData.length > 0 ?
                                        detail?.expertsData.map((rs, idx) => {
                                            return (
                                                <>
                                                    {
                                                        rs.workTypeId === 2 && !isPublished ?
                                                            <div key={idx} className="card-body">
                                                                <h3>{Utils.cleanOutput(prop.lang === 'en' ? rs.title_en:rs.title)}</h3>
                                                                <div dangerouslySetInnerHTML={{__html: prop.lang === 'en' ? rs.detail_en:rs.detail}}></div>

                                                                {
                                                                    rs.embed ?
                                                                        <>
                                                                            <h3 className="mt-5 mb-2">{prop.lang === 'en' ? 'Relevant statistics':'สถิติที่เกี่ยวข้อง'}</h3>
                                                                            <div className="iframe-wrapper">
                                                                                <div className="iframe-container">
                                                                                    <div dangerouslySetInnerHTML={{__html: rs.embed}}></div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        : ''
                                                                }

                                                                {
                                                                    rs.embed2 ?
                                                                        <>
                                                                            <h3 className="mt-5 mb-2">{prop.lang === 'en' ? 'Relevant statistics':'สถิติที่เกี่ยวข้อง'}</h3>
                                                                            <div className="iframe-wrapper">
                                                                                <div className="iframe-container">
                                                                                    <div dangerouslySetInnerHTML={{__html: rs.embed2}}></div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        : ''
                                                                }

                                                                {
                                                                    rs.embed3 ?
                                                                        <>
                                                                            <h3 className="mt-5 mb-2">{prop.lang === 'en' ? 'Relevant statistics':'สถิติที่เกี่ยวข้อง'}</h3>
                                                                            <div className="iframe-wrapper">
                                                                                <div className="iframe-container">
                                                                                    <div dangerouslySetInnerHTML={{__html: rs.embed3}}></div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        : ''
                                                                }

                                                                {
                                                                    rs.embed4 ?
                                                                        <>
                                                                            <h3 className="mt-5 mb-2">{prop.lang === 'en' ? 'Relevant statistics':'สถิติที่เกี่ยวข้อง'}</h3>
                                                                            <div className="iframe-wrapper">
                                                                                <div className="iframe-container">
                                                                                    <div dangerouslySetInnerHTML={{__html: rs.embed4}}></div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        : ''
                                                                }

                                                                {
                                                                    rs.embed5 ?
                                                                        <>
                                                                            <h3 className="mt-5 mb-2">{prop.lang === 'en' ? 'Relevant statistics':'สถิติที่เกี่ยวข้อง'}</h3>
                                                                            <div className="iframe-wrapper">
                                                                                <div className="iframe-container">
                                                                                    <div dangerouslySetInnerHTML={{__html: rs.embed5}}></div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        : ''
                                                                }
                                                            </div> : ''
                                                    }
                                                </>
                                            )
                                        }) : <p className="text-center">{prop.lang === 'en' ? 'Data Not Found':'ไม่พบข้อมูล'}</p>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="p-3"></div>
                </div>
            </div>
        </>
    );
} 